





















import vue from "vue";
import {
  LimitedModeDetails,
  LimitedModeExercise,
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";
import { dateTimeStringToLocaleString } from "@tt-app/utils";
import GoToExerciseMixin from "@tt-app/components/exercise/mixins/GoToExerciseMixin";

import LiveExerciseListItem from "@tt-app/components/terratalkLive/LiveExerciseListItem.vue";

interface Methods {
  routeToExercise: (exerciseDetails: LimitedModeExercise) => void;
}

interface Computed {
  endTimeString: string;
  limitedModeDetails: LimitedModeDetails;
  limitedModeExercises: LimitedModeExercise[];
}

export default vue.extend<Record<any, any>, Methods, Computed, Record<any, any>>({
  name: "LimitedModeDetails",

  components: { LiveExerciseListItem },

  mixins: [GoToExerciseMixin],

  methods: {
    routeToExercise(exerciseDetails) {
      this.goToExerciseFromExerciseEntry(exerciseDetails);
    }
  },

  computed: {
    endTimeString() {
      return dateTimeStringToLocaleString(this.limitedModeDetails?.endsAt) || "";
    },

    limitedModeDetails() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.LIMITED_MODE_DETAILS}`
      ];
    },

    limitedModeExercises() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.LIMITED_MODE_EXERCISES}`
      ];
    }
  }
});
